// extracted by mini-css-extract-plugin
export default {"spinner":"Loading_spinner__3pbPI"};